import { LabelKey } from '@shared/models';
import { ElasticSearchResponse } from '@shared/services/elastic-search/models';

export const filterSinkTapPacksSerializer = (filters: ElasticSearchResponse<unknown>): LabelKey[] => {
  return (
    filters.aggregations?.filtres_uniques.buckets.map((filter) => ({
      key: filter.key,
      label: filter.key,
    })) ?? []
  );
};
